export default "__VITE_ASSET__2t5iPtZC__"